import React from 'react';
import Moment from 'react-moment';

import moment from 'moment';
import 'moment/locale/es';
import 'moment-timezone';


Moment.globalMoment = moment;
Moment.globalLocale = 'es';
Moment.globalTimezone = 'America/Mexico_City';


const formatoModena = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
});

//const opcionesFecha = { timeZone: 'America/Mexico_City', weekday: "long", year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric", hour12: "false" };
const servicioFormatos = {

  formatearModena(valor) {
    return formatoModena.format(valor);
  },

  formatearFecha(valor) {
    if (null === valor || undefined === valor) {
      return null;
    } else {
      let fecha = new Date(valor);
      return <Moment date={fecha} format="YYYY-MM-DD"></Moment>

    }
  },

  formatearFechaSinSegundos(valor) {
    if (null === valor || undefined === valor) {
      return null;
    } else {
      let fecha = new Date(valor);
      return <Moment date={fecha} format="YYYY-MMMM-DD"></Moment>;
    }
  },
  formatearFechaString(valor) {
    if (null === valor || undefined === valor) {
      return null;
    } else {
      let fecha = moment(valor).format('YYYY-MM-DD HH:mm:ss');
      return fecha;
    }
  },
  formatoEstadoCfdi(valor) {
    if (valor === 1)
      return <p style={{ backgroundColor: '#bcbcbc', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Timbrado</p>
    if (valor === 0)
      return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Cancelado</p>
  },
  formatoNomina(valor){
    if(valor==='O')
    return "Ordinaria"
  }


}

export default servicioFormatos;